import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { tileMinWidth } from '@carvana/merch-tile';
import React from 'react';
import { useRef } from 'react';
import { CarouselSettings } from '@/common/Carousel/types';
import { useIsMobile, useScreenSize } from '~/context/common/DeviceContext';

const minTileWidth = tileMinWidth;
const mobileCarouselGap = 16;
const tabletCarouselGap = 24;

export default function useCarouselSettings(
  customSettings: Partial<CarouselSettings> = {}
): {
  carouselRef: React.RefObject<HTMLElement | null>;
  values: CarouselSettings;
} {
  const { width: screenWidth } = useScreenSize();
  const carouselRef = useRef<HTMLElement>(null);
  const isMobile = useIsMobile();
  const horizontalPageMargin = 48;

  const calculateWidth = () => {
    const carouselGap = isMobile ? mobileCarouselGap : tabletCarouselGap;
    const tileAndGap = customSettings.widthGap || minTileWidth + carouselGap;
    const workingWidth =
      carouselRef?.current?.offsetWidth || screenWidth - horizontalPageMargin;

    return workingWidth / tileAndGap;
  };

  const getSlidesToShow = () => {
    const calculatedWidth = calculateWidth();

    if (calculatedWidth < 1) {
      return 1;
    }

    if (screenWidth >= legacyBreakpoints.l) {
      return screenWidth >= legacyBreakpoints.xl ? 4 : 3;
    }

    return calculatedWidth;
  };

  const defaultSettings: CarouselSettings = {
    arrows: false,
    centerMode: false,
    className: '',
    dots: false,
    heading: '',
    eventBaseName: 'Home feed card',
    infinite: false,
    isSkeleton: false,
    slidesToShow: getSlidesToShow(),
    slidesToScroll: Math.floor(getSlidesToShow())
  };

  const values: CarouselSettings = { ...defaultSettings, ...customSettings };

  return { carouselRef, values };
}
